// i18n catalog — AdminOverview page (namespace: overview.*)
// EN values copied VERBATIM from frontend/src/pages/AdminOverview.js.
// AR values = Modern Standard Arabic. Numbers, currency, platform/brand
// names are intentionally NOT translated and are interpolated at runtime.
export const en = {
  // Section heading
  "overview.title": "Overview",

  // Period prefix labels (KPI card label prefixes / subtitle tokens)
  "overview.period.ytd": "YTD",
  "overview.period.today": "Today",
  "overview.period.custom": "Custom",
  // Subtitle period descriptors
  "overview.period.ytd2026": "YTD 2026",
  "overview.period.lastRange": "Last",

  // Platform filter label (when no single channel selected)
  "overview.filter.allPlatforms": "All platforms",

  // KPI card labels (period prefix is interpolated before each)
  "overview.kpi.gross": "Gross",
  "overview.kpi.netRecv": "Net Recv.",
  "overview.kpi.vatPaid": "VAT Paid",
  "overview.kpi.profitPreFixed": "Profit (pre-fixed)",
  // YoY comparison suffix ("…% vs 2025") — only the static tail
  "overview.kpi.vs2025": "vs 2025",

  // Profit chart titles
  "overview.chart.dailyTrueProfit": "Daily true profit",
  "overview.chart.monthlyTrueProfit": "Monthly true profit",
  "overview.chart.trueProfit": "True profit",
  "overview.chart.perDay": "per day",
  "overview.chart.perMonth": "per month",
  "overview.chart.trueProfitLegend": "True Profit",

  // Applied rates card
  "overview.rates.title": "Applied rates",
  "overview.rates.vatRate": "VAT rate",
  "overview.rates.cogs": "COGS",
  "overview.rates.commSuffix": "comm.",
  "overview.rates.cardFeeSuffix": "card fee",
  "overview.rates.commission": "Commission",
  "overview.rates.cardFee": "Card fee",
  "overview.rates.seeChannel": "see channel",
  "overview.rates.editInConfig": "Edit in Configuration →",

  // Earnings (contribution margin) card
  "overview.earnings.title": "Earnings",
  "overview.earnings.desc": "What you keep after every per-order cost (commission, card fee, VAT, food cost) — before fixed overheads like rent and wages",
  "overview.earnings.healthy": "✓ Healthy (≥25%)",
  "overview.earnings.below25": "⚠ Below 25%",
  "overview.earnings.profit": "Profit",
  "overview.earnings.beforeFixedOverheads": "before fixed overheads",
  "overview.earnings.marginPct": "Margin %",
  "overview.earnings.ofGrossSales": "of gross sales",
  "overview.earnings.trueProfit": "True profit",
  "overview.earnings.noFixedCosts": "no fixed costs set",
  // True-profit footnote pieces: "{periodFixed} fixed deducted ({monthly}/mo[ allocated] × {days}d)"
  "overview.earnings.fixedDeducted": "fixed deducted",
  "overview.earnings.perMo": "/mo",
  "overview.earnings.allocated": "allocated",
  "overview.earnings.daysAbbrev": "d",

  // Break-even analysis card
  "overview.breakeven.title": "Break-even analysis",
  "overview.breakeven.setFixedCostsPre": "Set your monthly fixed costs in ",
  "overview.breakeven.configLink": "Configuration",
  "overview.breakeven.setFixedCostsPost": " to see break-even targets and coverage.",
  "overview.breakeven.days": "days",
  "overview.breakeven.fixedCostsPerMo": "/mo fixed costs",
  "overview.breakeven.above": "✓ Above break-even",
  "overview.breakeven.below": "⚠ Below break-even",
  "overview.breakeven.dailyFixed": "Daily fixed",
  "overview.breakeven.perDay": "per day",
  "overview.breakeven.breakEvenGross": "Break-even gross",
  "overview.breakeven.targetPerDay": "target per day",
  "overview.breakeven.avgDailyGross": "Avg daily gross",
  "overview.breakeven.actual": "actual",
  "overview.breakeven.coverage": "Coverage",
  "overview.breakeven.afterFixed": "after fixed",
  // Load warnings
  "overview.warn.coFundLoadFailed": "Platform contributions couldn't be loaded, so these figures don't include them. Refresh the page to try again.",
};

export const ar = {
  // Section heading
  "overview.title": "نظرة عامة",

  // Period prefix labels
  "overview.period.ytd": "حتى تاريخه",
  "overview.period.today": "اليوم",
  "overview.period.custom": "مخصّص",
  // Subtitle period descriptors
  "overview.period.ytd2026": "حتى تاريخه 2026",
  "overview.period.lastRange": "آخر",

  // Platform filter label
  "overview.filter.allPlatforms": "كل المنصّات",

  // KPI card labels
  "overview.kpi.gross": "الإجمالي",
  "overview.kpi.netRecv": "صافي المستحق",
  "overview.kpi.vatPaid": "ضريبة القيمة المضافة المدفوعة",
  "overview.kpi.profitPreFixed": "الربح (قبل التكاليف الثابتة)",
  "overview.kpi.vs2025": "مقارنةً بعام 2025",

  // Profit chart titles
  "overview.chart.dailyTrueProfit": "الربح الحقيقي اليومي",
  "overview.chart.monthlyTrueProfit": "الربح الحقيقي الشهري",
  "overview.chart.trueProfit": "الربح الحقيقي",
  "overview.chart.perDay": "لكل يوم",
  "overview.chart.perMonth": "لكل شهر",
  "overview.chart.trueProfitLegend": "الربح الحقيقي",

  // Applied rates card
  "overview.rates.title": "المعدّلات المطبَّقة",
  "overview.rates.vatRate": "معدّل ضريبة القيمة المضافة",
  "overview.rates.cogs": "تكلفة البضاعة المباعة",
  "overview.rates.commSuffix": "عمولة",
  "overview.rates.cardFeeSuffix": "رسوم البطاقة",
  "overview.rates.commission": "العمولة",
  "overview.rates.cardFee": "رسوم البطاقة",
  "overview.rates.seeChannel": "راجع القناة",
  "overview.rates.editInConfig": "التعديل في الإعدادات ←",

  // Earnings card
  "overview.earnings.title": "الأرباح",
  "overview.earnings.desc": "ما تحتفظ به بعد كل تكلفة لكل طلب (العمولة، رسوم البطاقة، ضريبة القيمة المضافة، تكلفة الطعام) — قبل النفقات الثابتة مثل الإيجار والأجور",
  "overview.earnings.healthy": "✓ سليم (≥25%)",
  "overview.earnings.below25": "⚠ أقل من 25%",
  "overview.earnings.profit": "الربح",
  "overview.earnings.beforeFixedOverheads": "قبل النفقات الثابتة",
  "overview.earnings.marginPct": "نسبة الهامش %",
  "overview.earnings.ofGrossSales": "من إجمالي المبيعات",
  "overview.earnings.trueProfit": "الربح الحقيقي",
  "overview.earnings.noFixedCosts": "لم تُحدَّد تكاليف ثابتة",
  "overview.earnings.fixedDeducted": "تكاليف ثابتة مخصومة",
  "overview.earnings.perMo": "/شهر",
  "overview.earnings.allocated": "مُوزَّعة",
  "overview.earnings.daysAbbrev": "ي",

  // Break-even analysis card
  "overview.breakeven.title": "تحليل نقطة التعادل",
  "overview.breakeven.setFixedCostsPre": "حدّد تكاليفك الثابتة الشهرية في ",
  "overview.breakeven.configLink": "الإعدادات",
  "overview.breakeven.setFixedCostsPost": " لعرض أهداف نقطة التعادل والتغطية.",
  "overview.breakeven.days": "يوم",
  "overview.breakeven.fixedCostsPerMo": "/شهر تكاليف ثابتة",
  "overview.breakeven.above": "✓ فوق نقطة التعادل",
  "overview.breakeven.below": "⚠ دون نقطة التعادل",
  "overview.breakeven.dailyFixed": "ثابت يومي",
  "overview.breakeven.perDay": "لكل يوم",
  "overview.breakeven.breakEvenGross": "إجمالي نقطة التعادل",
  "overview.breakeven.targetPerDay": "الهدف لكل يوم",
  "overview.breakeven.avgDailyGross": "متوسط الإجمالي اليومي",
  "overview.breakeven.actual": "الفعلي",
  "overview.breakeven.coverage": "التغطية",
  "overview.breakeven.afterFixed": "بعد التكاليف الثابتة",
  // Load warnings
  "overview.warn.coFundLoadFailed": "تعذّر تحميل مساهمات المنصات، لذا لا تشملها هذه الأرقام. حدّث الصفحة للمحاولة مرة أخرى.",
};
